export var FulfillmentMethodType;
(function (FulfillmentMethodType) {
    /** Unknown fulfillment type. */
    FulfillmentMethodType["UNKNOWN_FULFILLMENT_TYPE"] = "UNKNOWN_FULFILLMENT_TYPE";
    /** The customer must pick up the order from the restaurant. */
    FulfillmentMethodType["PICKUP"] = "PICKUP";
    /** The restaurant, or someone on behalf of the restaurant, must deliver the order to the customer. */
    FulfillmentMethodType["DELIVERY"] = "DELIVERY";
})(FulfillmentMethodType || (FulfillmentMethodType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var Type;
(function (Type) {
    /** Unknown delivery area type. */
    Type["UNKNOWN_DELIVERY_AREA"] = "UNKNOWN_DELIVERY_AREA";
    /** Delivery area defined by a radius around the restaurant's address. */
    Type["RADIUS"] = "RADIUS";
    /** Delivery area defined by a list of postal codes. */
    Type["POSTAL_CODE"] = "POSTAL_CODE";
    /** Delivery area defined by a custom polygon. */
    Type["CUSTOM"] = "CUSTOM";
    /** Delivery area that is determined by the provider. Setting this option, you must also provide `delivery_provider_app_id`. */
    Type["PROVIDER_DEFINED"] = "PROVIDER_DEFINED";
})(Type || (Type = {}));
export var Unit;
(function (Unit) {
    /** Unknown unit. */
    Unit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** Miles. */
    Unit["MILES"] = "MILES";
    /** Kilometers. */
    Unit["KILOMETERS"] = "KILOMETERS";
})(Unit || (Unit = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    /** Monday. */
    DayOfWeek["MON"] = "MON";
    /** Tuesday. */
    DayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    DayOfWeek["WED"] = "WED";
    /** Thursday. */
    DayOfWeek["THU"] = "THU";
    /** Friday. */
    DayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    DayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map